import { Navigate, useRoutes } from 'react-router-dom';
// context
import { BusinessTagsProvider } from '../contexts/BusinessTagsContext';
import { VendorProvider } from '../contexts/VendorContext';
import { EventTagsProvider } from '../contexts/EventTagsContext';
import { CampaignPackageProvider } from '../contexts/CampaignPackageContext';
import { CampaignCreditsProvider } from '../contexts/CampaignCreditsContext';
import { CampaignTemplateProvider } from '../contexts/CampaignTemplateContext';
import { EventsTemplateProvider } from '../contexts/EventsDetailsContext';
import { DiscountTemplateProvider } from '../contexts/discountContext';
import { VenueTemplateProvider } from '../contexts/VenuesTemplateProvider';
// auth
import AuthGuard from '../auth/AuthGuard';
import GuestGuard from '../auth/GuestGuard';
// layouts
import CompactLayout from '../layouts/compact';
import DashboardLayout from '../layouts/dashboard';
// config
import { PATH_AFTER_LOGIN } from '../config-global';
//
import {
  Page404,
  LoginPage,
  Dashboard,
  VendorsList,
  CreateEditVendor,
  UpdateVendor,
  BusinessTagsList,
  CreateEditBusinessTags,
  EventTagsList,
  CreateEditEventTags,
  CancelTickets,
  AddCancelTickets,
  TicketOrders,
  SponsoredEvents,
  SponsoredEventsCreate,
  // CreateEvents,
  Customer,
  CreditsPackageList,
  CreateEditCreditPackage,
  AddCreditsList,
  AddTemplateList,
  AddCampaignCredits,
  AddCampaignTemplate,
  Maintenance,
  Platform,
  Platformhistroy,
  SetPlatformfee,
  UpdatePlatformfee,
  Invoices,
  CreateInvoice,
  CustomerInvoice,
  CreateGroupEvents,
  GroupEvents,
  Events,
  DiscountDashboard,
  // Maintenance,
  // PackagesList,
  // CreateEditpackages,
  EventRecords,
  CreateDiscount,
  DiscountDetails,
  UpdateDiscount,
  VenuesDashboard,
  VenuePerDetails,
  UpdateVenue,
  EventSlotPage,
  CreateEventSlotPage,
  ArtistDetails,
  ArtistDashboard,
  EventLabelDashboard,
  CreateEventLabel,
  EventCreateStrikeOutPrice,
  UpdateEventLabel,
  EventStrikeDashboard,
  EventUpdateStrikeOutPrice,
  CreateEvents,
  BlogsDashBoard,
  CreateBlog,
  BlogPrev,
  VenueCategoryDashboard,
  StaffPage,
  UpdateStaff,
  TableManagement,
  BookingSettings,
  SlotManagementPage,
  ReOrder,
  AddSlotsPage,
  FloorPlan,
  ConfigurationDashboard,
  SettleMentDashboard,
  SettleAmountPage,
  CategoryMappingDashboard,
  AddCategoryMapping,
  QRBandDashboard,
  QRBandCreate,
} from './elements';
import CreateCampianTemplete from '../pages/campaign/add-template/CreateCampianTemplete';
import AddGroupPage from 'src/pages/campaign/add-group/add-group-page';
import UsersPage from 'src/pages/users/users-page';
import CreateUser from 'src/pages/users/create-user';
import GenerateInvoice from 'src/pages/invoices/generate-invoice';
import CreateCampaignTemplateDefault from 'src/pages/campaign/add-template/CreateCampianTempleteDefault';
import DevicesAdd from 'src/pages/vendors/DevicesAdd';
import { element } from 'prop-types';
import AllCampaign from 'src/pages/campaign/vendors/all-campaign';
import CampaignView from 'src/pages/campaign/vendors/CampaignView';
import ClearEntryPage from 'src/pages/clear-entry/clear-entry-page';
import HandleEntry from 'src/pages/clear-entry/handle-entry';
import RequestEvent from 'src/pages/events/request-event';
import EventDetails from 'src/pages/events/EventDetails';
import PaymentSummaryPage from 'src/pages/payment-summary/payment-summary-page';
import GenerateQrPage from 'src/pages/generate-qr/generate-qr-page';

// ----------------------------------------------------------------------

export default function Router() {
  return useRoutes([
    {
      path: '/',
      children: [
        { element: <Navigate to={PATH_AFTER_LOGIN} replace />, index: true },
        {
          path: 'login',
          element: (
            <GuestGuard>
              <LoginPage />
            </GuestGuard>
          ),
        },
      ],
    },
    {
      path: '/dashboard',
      element: (
        <AuthGuard>
          <DashboardLayout />
        </AuthGuard>
      ),
      children: [
        { element: <Navigate to={PATH_AFTER_LOGIN} replace />, index: true },
        {
          children: [
            {
              path: 'dashboard',
              children: [{ element: <Dashboard />, index: true }],
            },
          ],
        },
        {
          element: <BusinessTagsProvider />,
          children: [
            {
              path: 'vendors',
              element: <VendorProvider />,
              children: [
                {
                  children: [
                    { element: <VendorsList />, index: true },
                    { path: 'create', element: <CreateEditVendor /> },
                    { path: 'update/:id', element: <UpdateVendor /> },
                    {
                      path: 'histroy',
                      element: <Platformhistroy />,
                    },
                  ],
                },
              ],
            },
            {
              path: 'platformfee', // This is the parent path for Platform and SetPlatformfee
              children: [
                { element: <Platform />, index: true },
                {
                  path: 'create', // This path should render the SetPlatformfee component
                  element: <SetPlatformfee />,
                },

                {
                  path: 'update',
                  element: <UpdatePlatformfee />,
                },
              ],
            },
            {
              path: 'invoices',
              element: <VendorProvider />,
              children: [
                { element: <Invoices />, index: true },
                { path: 'create', element: <GenerateInvoice /> },
                { path: 'customerinvoice', element: <CustomerInvoice /> },
              ],
            },

            {
              path: 'business-tags',
              children: [
                { element: <BusinessTagsList />, index: true },
                { path: 'create', element: <CreateEditBusinessTags /> },
                { path: 'edit/:name', element: <CreateEditBusinessTags edit /> },
              ],
            },
          ],
        },

        // {
        //   path: 'packages',
        //   children: [
        //     { element: <Navigate to="/dashboard/packages/packages-list" replace />, index: true },
        //     { path: 'packages-list', element: <PackagesList /> },
        //     { path: 'create-edit-packages', element: <CreateEditpackages /> },
        //   ],
        // },
        {
          path: 'event-tags',
          children: [
            {
              element: <EventTagsProvider />,
              children: [
                {
                  element: <EventTagsList />,
                  index: true,
                },
                { path: 'create', element: <CreateEditEventTags /> },
                { path: 'edit/:_id', element: <CreateEditEventTags edit /> },
              ],
            },
          ],
        },
        {
          path: 'events',
          children: [
            {
              element: <EventsTemplateProvider />,
              children: [
                {
                  element: <Events />,
                  index: true,
                },
                {
                  path: 'event-record/:id',
                  element: <EventRecords />,
                },
                {
                  path: 'request',
                  element: <RequestEvent />,
                },
                {
                  path: 'view/:handle',
                  element: <EventDetails />,
                },
                {
                  path: '/dashboard/events/:type',
                  element: <CreateEvents />,
                },
                {
                  path: '/dashboard/events/edit-event/:handle/:type',
                  element: <CreateEvents isEdit />,
                },
              ],
            },
          ],
        },
        {
          path: 'discount',
          children: [
            {
              element: <DiscountTemplateProvider />,
              children: [
                {
                  element: <DiscountDashboard />,
                  index: true,
                },
                {
                  path: 'create_discount',
                  element: <CreateDiscount />,
                },
                {
                  path: '/dashboard/discount/:id',
                  element: <DiscountDetails />,
                },
                {
                  path: '/dashboard/discount/update/:id',
                  element: <UpdateDiscount />,
                },
              ],
            },
          ],
        },

        {
          path: 'Venues',
          children: [
            {
              element: <VenueTemplateProvider />,
              children: [
                {
                  element: <VenuesDashboard />,
                  index: true,
                },

                {
                  path: '/dashboard/Venues/:short_name',
                  element: <VenuePerDetails />,
                },
                {
                  path: '/dashboard/Venues/type/:type',
                  element: <UpdateVenue />,
                },
                {
                  path: '/dashboard/Venues/category',
                  element: <VenueCategoryDashboard />,
                },
              ],
            },
          ],
        },

        {
          path: 'configuration',
          children: [
            {
              element: <VenueTemplateProvider />,
              children: [
                {
                  element: <ConfigurationDashboard />,
                  index: true,
                },
              ],
            },
          ],
        },

        {
          path: 'Blogs',
          children: [
            {
              element: <VenueTemplateProvider />,
              children: [
                {
                  element: <BlogsDashBoard />,
                  index: true,
                },
                { path: 'create', element: <CreateBlog /> },
                { path: 'edit/:id', element: <CreateBlog edit /> },
                { path: 'PreviewsBlog', element: <BlogPrev /> },
              ],
            },
          ],
        },

        {
          path: 'EventLabels',
          children: [
            {
              element: <VenueTemplateProvider />,
              children: [
                {
                  element: <EventLabelDashboard />,
                  index: true,
                },
                {
                  path: 'create_eventLabel',
                  element: <CreateEventLabel />,
                },

                {
                  path: '/dashboard/EventLabels/create_Strike_out_price',
                  element: <EventCreateStrikeOutPrice />,
                },
                {
                  path: '/dashboard/EventLabels/:id',
                  element: <UpdateEventLabel />,
                },
                // {
                //   path: '/dashboard/Venues/update/:id',
                //   element: <UpdateVenue />,
                // },
              ],
            },
          ],
        },

        {
          path: 'EventStrikes',
          children: [
            {
              element: <VenueTemplateProvider />,
              children: [
                {
                  element: <EventStrikeDashboard />,
                  index: true,
                },

                {
                  path: '/dashboard/EventStrikes/create_Strike_out_price',
                  element: <EventCreateStrikeOutPrice />,
                },

                {
                  path: '/dashboard/EventStrikes/:id',
                  element: <EventUpdateStrikeOutPrice />,
                },
                // {
                //   path: '/dashboard/Venues/update/:id',
                //   element: <UpdateVenue />,
                // },
              ],
            },
          ],
        },

        {
          path: 'artist',
          children: [
            {
              path: '/dashboard/artist',
              element: <ArtistDashboard />,
            },
            {
              path: '/dashboard/artist/details/:artistId/:mobile',
              element: <ArtistDetails />,
            },
          ],
        },

        {
          path: 'ticket-orders',
          element: <VendorProvider />,
          children: [
            {
              element: <TicketOrders />,
              index: true,
            },
          ],
        },
        {
          path: 'pos',
          element: <VendorProvider />,
          children: [
            {
              element: <DevicesAdd />,
              index: true,
            },
          ],
        },
        {
          path: 'staff',
          children: [
            {
              element: <VenueTemplateProvider />,
              children: [
                {
                  element: <StaffPage />,
                  index: true,
                },
                {
                  path: '/dashboard/staff/edit/:id',
                  element: <UpdateStaff />,
                },
                {
                  path: '/dashboard/staff/create',
                  element: <UpdateStaff />,
                },
              ],
            },
          ],
        },

        {
          path: 'sponsored-events',
          element: <VendorProvider />,
          children: [
            {
              element: <SponsoredEvents />,
              index: true,
            },
            { path: 'create', element: <SponsoredEventsCreate /> },
          ],
        },
        {
          path: 'group-events',
          children: [
            {
              element: <GroupEvents />,
              index: true,
            },
            { path: 'create', element: <CreateGroupEvents /> },
            { path: 'edit/:name', element: <CreateGroupEvents edit /> },
          ],
        },

        {
          path: 'cancel-tickets',
          element: <VendorProvider />,
          children: [
            {
              element: <CancelTickets />,
              index: true,
            },
            { path: 'create', element: <AddCancelTickets /> },
          ],
        },
        {
          path: 'customer',
          children: [
            {
              element: <Customer />,
              index: true,
            },
          ],
        },
        {
          path: 'payment-summary',
          children: [
            {
              element: <PaymentSummaryPage />,
              index: true,
            },
          ],
        },
        {
          path: 'generate-qr',
          element: <VendorProvider />,
          children: [
            {
              element: <GenerateQrPage />,
              index: true,
            },
          ],
        },
        {
          path: 'event-slot',
          element: <VendorProvider />,
          children: [
            {
              element: <EventSlotPage />,
              index: true,
            },
            {
              element: <CreateEventSlotPage />,
              path: 'create',
            },
          ],
        },

        {
          path: 'campaign',
          element: <VendorProvider />,
          children: [
            {
              path: 'package',
              element: <CampaignPackageProvider />,
              children: [
                {
                  element: <CreditsPackageList />,
                  index: true,
                },

                {
                  element: <CreateEditCreditPackage />,
                  path: 'create',
                },
                { path: 'edit/:name', element: <CreateEditCreditPackage edit /> },
              ],
            },
            {
              path: 'all',
              element: <VendorProvider />,
              children: [
                {
                  element: <AllCampaign />,
                  index: true,
                },

                {
                  element: <CampaignView />,
                  path: 'view/:_id',
                },
              ],
            },
            {
              path: 'template',
              element: <CampaignTemplateProvider />,
              children: [
                {
                  element: <AddTemplateList />,
                  index: true,
                },

                {
                  element: <AddCampaignTemplate />,
                  path: 'add',
                },
                {
                  element: <CreateCampianTemplete />,
                  path: 'create',
                },
                {
                  element: <CreateCampaignTemplateDefault />,
                  path: 'create-default',
                },
                { path: 'edit/:name', element: <CreateEditCreditPackage edit /> },
              ],
            },

            {
              path: 'group',
              element: <CampaignTemplateProvider />,
              children: [
                {
                  element: <AddGroupPage />,
                  index: true,
                },
              ],
            },
            {
              path: 'credits',
              element: <CampaignCreditsProvider />,
              children: [
                {
                  element: <AddCreditsList />,
                  index: true,
                },

                {
                  element: <AddCampaignCredits />,
                  path: 'add',
                },
                { path: 'edit/:name', element: <AddCampaignCredits edit /> },
              ],
            },

            // { path: 'create', element: <CreateEvents /> },
          ],
        },
        {
          path: 'TableManagement',
          element: <VendorProvider />,
          children: [
            {
              element: <TableManagement />,
              index: true,
            },
            {
              path: 'booking-settings/:id',
              element: <BookingSettings />,
            },
            {
              path: 'booking-settings/slot-management/:vendorId',
              element: <SlotManagementPage />,
            },
            {
              path: 'booking-settings/re-order/:vendorId',
              element: <ReOrder />,
            },
            {
              path: 'booking-settings/add-slots/:vendorId',
              element: <AddSlotsPage />,
            },
            {
              path: 'booking-settings/floor-plan/:vendorId',
              element: <FloorPlan />,
            },
          ],
        },
        {
          path: 'settlements',
          children: [
            {
              element: <VenueTemplateProvider />,
              children: [
                {
                  element: <SettleMentDashboard />,
                  index: true,
                },

                {
                  path: '/dashboard/settlements/settle-amount',
                  element: <SettleAmountPage />,
                },

                // {
                //   path: '/dashboard/settlements/settle-amount/:_id',
                //   element: <SettleAmountPage />,
                // },
              ],
            },
          ],
        },
        {
          path: 'category-mapping',
          children: [
            {
              element: <VenueTemplateProvider />,
              children: [
                {
                  element: <CategoryMappingDashboard />,
                  index: true,
                },
                {
                  path: '/dashboard/category-mapping/addEdit',
                  element: <AddCategoryMapping />,
                },
              ],
            },
          ],
        },
        {
          path: 'users',
          children: [
            {
              element: <UsersPage />,
              index: true,
            },
            {
              element: <CreateUser />,
              path: 'create',
            },
          ],
        },
        {
          path: 'maintenance',
          children: [
            {
              element: <Maintenance />,
              index: true,
            },
          ],
        },
        {
          path: 'qrband',
          children: [
            {
              element: <VenueTemplateProvider />,
              children: [
                {
                  element: <QRBandDashboard />,
                  index: true,
                },
                {
                  path: '/dashboard/qrband/create',
                  element: <QRBandCreate />,
                },
              ],
            },
          ],
        },
        {
          path: 'clear-entry',
          children: [
            {
              element: <ClearEntryPage />,
              index: true,
            },
            {
              path: 'handle',
              element: <HandleEntry />,
            },
          ],
        },
      ],
    },
    {
      element: <CompactLayout />,
      children: [{ path: '404', element: <Page404 /> }],
    },
    { path: '*', element: <Navigate to="/404" replace /> },
  ]);
}
